import { render } from "./k-fileupload.vue?vue&type=template&id=8bb95154&scoped=true"
import script from "./k-fileupload.vue?vue&type=script&lang=js"
export * from "./k-fileupload.vue?vue&type=script&lang=js"

import "./k-fileupload.vue?vue&type=style&index=0&id=8bb95154&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8bb95154"]])

export default __exports__